import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import StructuredData from '@/components/base/StructuredData';
import ArticleCard from '@/components/base/ArticleCard';
import CTASection from '@/pages/home/components/CTASection';
import { categoryData, categoryArticles } from '@/mocks/categoryData';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categoryData[slug as keyof typeof categoryData];
  const articles = categoryArticles[slug as keyof typeof categoryArticles] || [];

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="pt-24 pb-16 text-center min-h-screen flex items-center justify-center">
          <div>
            <h1 className="text-2xl font-heading font-bold text-foreground-950">分类未找到</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <StructuredData type="category" categoryName={category.name} />
      <Navbar />
      <main>
        <section className="relative pt-24 pb-8 md:pt-32 md:pb-12 bg-background-50">
          <div className="px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-800 font-medium">{category.name}</span>
            </nav>

            <div className="flex justify-center mb-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-100 text-accent-800 text-sm">
                <i className="ri-price-tag-3-line"></i>
                <span className="whitespace-nowrap">{category.name} · 实时更新</span>
              </div>
            </div>

            <div className="text-center max-w-4xl mx-auto mb-8">
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight">
                {category.name}
              </h1>
              <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                {category.description}
              </p>
              <div className="flex items-center justify-center gap-3 mt-6">
                <button
                  type="button"
                  className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  最新爆料
                </button>
                <button
                  type="button"
                  className="px-6 py-3 rounded-full bg-background-50 text-foreground-800 text-sm font-medium border border-foreground-200 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  最热爆料
                </button>
              </div>
            </div>

            <div className="rounded-3xl overflow-hidden">
              <img
                src={category.image}
                alt={`吃瓜黑料网 - ${category.name}`}
                title={`吃瓜黑料网 - ${category.name}`}
                className="w-full h-[250px] md:h-[400px] object-cover object-top"
              />
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 gap-4">
                <div>
                  <p className="text-sm font-medium text-foreground-400 uppercase tracking-wider mb-1">
                    共 {articles.length} 条爆料
                  </p>
                  <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 italic">
                    {category.name}最新动态
                  </h2>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {articles.map((article, index) => (
                  <ArticleCard
                    key={article.id}
                    title={article.title}
                    category={article.category}
                    categorySlug={article.categorySlug}
                    date={article.date}
                    image={article.image}
                    slug={article.slug}
                    variant={index % 4 === 1 ? 'accent' : 'default'}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>

        <CTASection />
      </main>
      <Footer />
    </>
  );
}